module.exports = __webpack_public_path__ + "img/van-shuttle.80bed225.svg";